export default __webpack_public_path__ + "static/media/Montserrat-Bold.71e80a27.ttf";